<template>
  <content>
    <v-btn 
      v-for="(btn, index) in floatingButtons"
      :key="index"
      :style="{'margin-top': margTop + index * 52 + 'px'}"
      :class="btn.class"
      :to="btn.to"
      fab
      top
      right
      fixed
      small
      dark
      @click.prevent="getSelf()[btn.method](btn.payload)">
      <v-icon small>
        {{ btn.icon }}
      </v-icon>
    </v-btn>
  </content>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    margTop: 48,
    numberButtons: 0,
    hidden: false
  }),
  computed: {
    ...mapState({
      floatingButtons: state => state.navigation.responsive.floatingButtons,
      path: state => state.route.path,
      isMobile: state => state.isMobile,
      searchActive: state => state.searchActive

    }),

    floatingButtonsPath: function() {
      var i, a
      var buttons = this.floatingButtons
      var newButtons = []
      for (a = 0; a < buttons.length; a++) {
        for (i = 0; i < buttons[a].path.length; i++) {
          if (this.path === buttons[a].path[i]) {
            newButtons.push(buttons[a])
          }
        }
      }
      return newButtons
    }
  },

  methods: {
    ...mapMutations([
      'searchActivated',
      'setNavElementSearch',
      'clicktimelinedrawer',
      'click_profile_settingsdrawer',
    ]),
    
    checkPath(path) {
      var i
      var check = false
      for (i = 0; i < path.length; i++) {
        if (this.path === path[i]) {
          check = true
        }
      }
      return check
    },
    activateSearch (val) {
      this.searchActivated()
      this.setNavElementSearch(this.searchActive)
    },
    getSelf() {
      return this
    }
  }
}
</script>

<style lang="scss" scoped>
.addEvent {
  z-index: 5;
  border: 3px solid white;
  background-image: linear-gradient(330deg, #d81b60, #eeff41);
}

.openFilter {
  z-index: 5;
  border: 3px solid white;
  background-image: linear-gradient(330deg, #37474f, #cfd8dc);
}
</style>
